import './photos-banner.css';

import './img/hot_air_balloon-large.jpg';
import './img/hot_air_balloon-small.jpg';
